import { z } from 'zod';
import type { BoPhan, BoPhanSuDungTSCDInput } from '@/types/schemas';

export const departmentSchema = z.object({
  ma_bp: z.string().min(1, 'Mã bộ phận là bắt buộc'),
  ten_bp: z.string().min(1, 'Tên bộ phận là bắt buộc'),
  ten_bp2: z.string().optional().nullable(),
  ma_bp_phi: z.string().optional().nullable(),
  ma_bp_phi_name: z.string().optional().nullable(),
  ma_bp_phi_data: z.custom<BoPhan>().nullable().optional(),
  ghi_chu: z.string().optional().nullable(),
  status: z.string().or(z.number()).default('1')
});

export type DepartmentFormValues = z.infer<typeof departmentSchema>;

export const initialFormValues: DepartmentFormValues = {
  ma_bp: '',
  ten_bp: '',
  ten_bp2: '',
  ma_bp_phi: null,
  ma_bp_phi_name: '',
  ma_bp_phi_data: null,
  ghi_chu: '',
  status: '1'
};

export type DepartmentFormattedData = BoPhanSuDungTSCDInput;
export type { BoPhanSuDungTSCD } from '@/types/schemas';

export const departmentSearchColumns = [
  { field: 'ma_bp', headerName: 'Mã bộ phận', width: 150 },
  { field: 'ten_bp', headerName: 'Tên bộ phận', width: 250 },
  { field: 'uuid', headerName: 'UUID', width: 0, hide: true }
];
